import { render, staticRenderFns } from "./VerReceta.vue?vue&type=template&id=70a229a0&scoped=true"
import script from "./VerReceta.vue?vue&type=script&lang=js"
export * from "./VerReceta.vue?vue&type=script&lang=js"
import style0 from "./VerReceta.vue?vue&type=style&index=0&id=70a229a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a229a0",
  null
  
)

export default component.exports